import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	CircularProgress,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	Stack,
	Tab,
	Tabs,
	TextField,
	Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import GameProviderImages from "src/components/game-provider-configs/GameProviderImages";
import { post, put } from "src/utils/networkUtils";

export enum GameProviderStatus {
	DRAFT,
	ACTIVE,
}

const langs = [
	{ key: "en", label: "English" },
	// { key: 'fr', label: 'French' },
];

// TabPanel component for language tabs
function TabPanel({ children, value, index, ...other }) {
	return (
		<div role="tabpanel" hidden={value !== index} id={`language-tabpanel-${index}`} aria-labelledby={`language-tab-${index}`} {...other}>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

export default function GameProviderEditPage(props) {
	const { id } = useParams();
	const { currentGameProvider } = useSelector((state) => state.gameProvider);

	const [gameProvider, setGameProvider] = useState(
		currentGameProvider || {
			goLiveAt: moment(),
			featuredExpiryDate: moment(),
			ownerType: 0,
			gameExternalId: "",
			isFeatured: false,
			isNew: false,
			gameProviderCode: "",
			gameProviderStatus: "0",
			gameProviderClientId: "",
			gameProviderSecret: "",
			gameProviderUrl: "",
			tags: [],
			imagesI18n: [],
			low6GameType: 0,
			backgroundColor: "#FF0000FF",
		},
	);

	const [activeLanguageTab, setActiveLanguageTab] = useState(0);

	const [loading, setLoading] = useState(!currentGameProvider);
	const navigate = useNavigate();

	useEffect(() => {
		if (id === "create") {
			setGameProvider({
				goLiveAt: null,
				featuredExpiryDate: moment(),
				ownerType: 0,
				gameExternalId: "",
				isFeatured: false,
				isNew: false,
				gameProviderCode: "",
				gameProviderStatus: GameProviderStatus.DRAFT,
				gameProviderClientId: "",
				gameProviderSecret: "",
				gameProviderUrl: "",
				tags: [],
				imagesI18n: [],
				low6GameType: 0,
				nameI18n: {
					en: "",
					fr: "",
				},
				descriptionI18n: {
					en: "",
					fr: "",
				},
				transactionNameI18n: {
					en: "",
					fr: "",
				},
				backgroundColor: "#FF0000FF",
			});
			setLoading(false);
		} else if (id && currentGameProvider) {
			setGameProvider(currentGameProvider);
			setLoading(false);
		} else {
			setLoading(false);
			navigate(-1);
		}
	}, [id, currentGameProvider, navigate]);

	const handleChange = (e) => {
		const { id, value } = e.target;
		setGameProvider((prevState) => ({
			...prevState,
			[id]: value,
		}));
	};

	const handleLanguageTabChange = (event, newValue) => {
		setActiveLanguageTab(newValue);
	};

	const onSuccess = () => {
		const dataToSubmit = {
			gameProviderClientId: gameProvider.gameProviderClientId,
			gameProviderCode: gameProvider.gameProviderCode,
			gameProviderSecret: gameProvider.gameProviderSecret,
			gameProviderStatus: gameProvider.gameProviderStatus,
			gameProviderUrl: gameProvider.gameProviderUrl,
			goLiveAt: gameProvider.goLiveAt,
			isFeatured: gameProvider.isFeatured,
			featuredExpiryDate: gameProvider.featuredExpiryDate,
			isNew: gameProvider.isNew,
			newExpiryDate: gameProvider.newExpiryDate || null,
			imagesI18n: gameProvider.imagesI18n || [],
			// tags: gameProvider.tags.length ? gameProvider.tags.map((item) => item.tagName) : [],
			ownerType: gameProvider.ownerType,
			gameExternalId: gameProvider.gameExternalId || "",
			gameProviderId: gameProvider.gameProviderId || "",
			low6GameType: gameProvider.low6GameType || 0,
			// Add multilingual data
			nameI18n: gameProvider.nameI18n,
			descriptionI18n: gameProvider.descriptionI18n,
			transactionNameI18n: gameProvider.transactionNameI18n,
			backgroundColor: gameProvider.backgroundColor,
		};

		setLoading(true);

		if (id === "create") {
			post("/admin/arcade", dataToSubmit)
				.then(() => {
					navigate(-1);
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					setLoading(false);
				});
		} else if (id && gameProvider.gameProviderId) {
			put(`/admin/arcade/${gameProvider.gameProviderId}`, dataToSubmit)
				.then(() => {
					props.onSuccessHandler?.();
					navigate(-1);
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					setLoading(false);
				});
		}
	};

	return (
		<Box sx={{ padding: 3 }}>
			<Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
				<Typography variant="h4" gutterBottom>
					Arcade Game
				</Typography>
				<Box>
					<Button variant="outlined" onClick={() => navigate(-1)} sx={{ mr: 1 }}>
						Cancel
					</Button>
					<Button variant="contained" onClick={onSuccess} disabled={loading}>
						Save
					</Button>
				</Box>
			</Stack>

			{gameProvider === null || loading ? (
				<Box sx={{ display: "flex", justifyContent: "center" }} style={{ padding: 20 }}>
					<CircularProgress />
				</Box>
			) : (
				<Grid container spacing={3}>
					{/* Basic Configuration & Game Details Card */}
					<Grid item xs={12}>
						<Card>
							<CardHeader title="Basic Configuration & Game Details" />
							<CardContent>
								<Grid container spacing={3}>
									{/* <Grid item xs={12} sm={3} md={3}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DateTimePicker
                        label='Go Live At*'
                        value={gameProvider.goLiveAt}
                        onChange={(value) =>
                          handleDateChange(value, 'goLiveAt')
                        }
                        renderInput={(params) => (
                          <TextField fullWidth {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid> */}
									{/* <Grid item xs={12} sm={3} md={3}>
                    <FormControl fullWidth size='small'>
                      <InputLabel id='featured-label'>Featured</InputLabel>
                      <Select
                        labelId='featured-label'
                        value={gameProvider.isFeatured}
                        label='Featured'
                        onChange={(event) =>
                          setGameProvider((prevState) => ({
                            ...prevState,
                            isFeatured: event.target.value,
                          }))
                        }
                      >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid> */}
									{/* <Grid item xs={12} sm={3} md={3}>
                    <FormControl fullWidth size='small'>
                      <InputLabel id='owner-type-label'>
                        Game Provider
                      </InputLabel>
                      <Select
                        labelId='owner-type-label'
                        value={gameProvider.ownerType}
                        label='Game Provider'
                        onChange={handleOwnerTypeChange}
                      >
                        <MenuItem value={0}>Low6</MenuItem>
                        <MenuItem value={1}>Marbles</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {gameProvider.ownerType === 0 && (
                    <Grid item xs={12} sm={3} md={3}>
                      <FormControl fullWidth size='small'>
                        <InputLabel id='low6-game-type-label'>
                          Low6 Game Type
                        </InputLabel>
                        <Select
                          labelId='low6-game-type-label'
                          value={gameProvider.low6GameType || 0}
                          label='Low6 Game Type'
                          onChange={(event) =>
                            setGameProvider((prevState) => ({
                              ...prevState,
                              low6GameType: event.target.value,
                            }))
                          }
                        >
                          {low6GameTypes.map((gameType) => (
                            <MenuItem
                              key={gameType.value}
                              value={gameType.value}
                            >
                              {gameType.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  )} */}
									{/* {gameProvider.isFeatured && (
                    <Grid item xs={12} sm={3} md={3}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DateTimePicker
                          label='Featured Expiry Date'
                          value={gameProvider.featuredExpiryDate}
                          onChange={(value) =>
                            handleDateChange(value, 'featuredExpiryDate')
                          }
                          renderInput={(params) => (
                            <TextField fullWidth {...params} />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  )} */}
									{/* <Grid item xs={12} sm={3} md={3}>
                    <FormControl fullWidth size='small'>
                      <InputLabel id='new-label'>New</InputLabel>
                      <Select
                        labelId='new-label'
                        value={gameProvider.isNew}
                        label='New'
                        onChange={(event) =>
                          setGameProvider((prevState) => ({
                            ...prevState,
                            isNew: event.target.value,
                          }))
                        }
                      >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid> */}
									{/* {gameProvider.isNew && (
                    <Grid item xs={12} sm={3} md={3}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DateTimePicker
                          label='New Expiry Date'
                          value={gameProvider.newExpiryDate}
                          onChange={(value) =>
                            handleDateChange(value, 'newExpiryDate')
                          }
                          renderInput={(params) => (
                            <TextField fullWidth {...params} />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  )} */}
									{/* <Grid item xs={12} sm={3}>
                    <TextField
                      id='gameProviderCode'
                      label='Game Code'
                      fullWidth
                      value={gameProvider.gameProviderCode}
                      variant='outlined'
                      onChange={handleChange}
                    />
                  </Grid> */}

									{/* Language Tabs */}
									{/* <Grid item xs={12}> */}
									<Grid item xs={6}>
										<TextField
											label={`Name`}
											fullWidth
											value={gameProvider.nameI18n?.en || ""}
											variant="outlined"
											onChange={(event) =>
												setGameProvider((prevState) => ({
													...prevState,
													nameI18n: {
														...prevState.nameI18n,
														en: event.target.value,
													},
												}))
											}
											// onChange={(e) => handleFieldChange('nameI18n', e.target.value)}
										/>
									</Grid>
									<Grid item xs={6}>
										<TextField
											label={`Transaction Name`}
											fullWidth
											value={gameProvider.transactionNameI18n?.en || ""}
											variant="outlined"
											onChange={(event) =>
												setGameProvider((prevState) => ({
													...prevState,
													transactionNameI18n: {
														...prevState.transactionNameI18n,
														en: event.target.value,
													},
												}))
											}
										/>
									</Grid>

									<Grid item xs={6}>
										<TextField
											id="gameProviderUrl"
											label="Game URL"
											fullWidth
											value={gameProvider.gameProviderUrl}
											variant="outlined"
											onChange={handleChange}
										/>
									</Grid>

									<Grid item xs={12} sm={6} md={4}>
										<FormControl fullWidth size="small">
											<InputLabel id="status-label">Status</InputLabel>
											<Select
												labelId="status-label"
												value={gameProvider.gameProviderStatus}
												label="Status"
												onChange={(event) =>
													setGameProvider((prevState) => ({
														...prevState,
														gameProviderStatus: event.target.value,
													}))
												}
											>
												<MenuItem value="0">DRAFT</MenuItem>
												<MenuItem value="1">ACTIVE</MenuItem>
											</Select>
										</FormControl>
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					</Grid>

					{/* Configuration Card */}
					{/* <Grid item xs={12}>
            <Card>
              <CardHeader title='Configuration' />
              <CardContent>
                <Grid container spacing={3}>
                  {gameProvider.ownerType === 0 ? (
                    <>
                      {id !== 'create' && (
                        <Grid item xs={6}>
                          <TextField
                            id='gameProviderClientId'
                            label='Client ID'
                            fullWidth
                            value={gameProvider.gameProviderClientId}
                            variant='outlined'
                            onChange={handleChange}
                          />
                        </Grid>
                      )}

                      {id !== 'create' && (
                        <Grid item xs={6}>
                          <TextField
                            id='gameProviderSecret'
                            label='Client Secret'
                            fullWidth
                            value={gameProvider.gameProviderSecret}
                            variant='outlined'
                            onChange={handleChange}
                          />
                        </Grid>
                      )}

                      <Grid item xs={6}>
                        <TextField
                          id='gameProviderUrl'
                          label='Game URL'
                          fullWidth
                          value={gameProvider.gameProviderUrl}
                          variant='outlined'
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth size='small'>
                          <InputLabel id='low6-game-type-config-label'>
                            Low6 Game Type
                          </InputLabel>
                          <Select
                            labelId='low6-game-type-config-label'
                            value={gameProvider.low6GameType || 0}
                            label='Low6 Game Type'
                            onChange={(event) =>
                              setGameProvider((prevState) => ({
                                ...prevState,
                                low6GameType: event.target.value,
                              }))
                            }
                          >
                            {low6GameTypes.map((gameType) => (
                              <MenuItem
                                key={gameType.value}
                                value={gameType.value}
                              >
                                {gameType.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </>
                  ) : (
                    <>
                      {gameProvider.ownerType === 1 && (
                        <>
                          <Grid item xs={12}>
                            <Grid container spacing={2} alignItems='flex-end'>
                              <Grid item xs={9}>
                                <FormControl fullWidth size='small'>
                                  <InputLabel id='marbles-game-label'>
                                    Marbles Game
                                  </InputLabel>
                                  <Select
                                    labelId='marbles-game-label'
                                    value={gameProvider.gameExternalId || ''}
                                    label='Marbles Game'
                                    onChange={(event) =>
                                      setGameProvider((prevState) => ({
                                        ...prevState,
                                        gameExternalId: event.target.value,
                                      }))
                                    }
                                  >
                                    <MenuItem value=''>
                                      <em>Select a game</em>
                                    </MenuItem>
                                    {marblesGames.map((game) => (
                                      <MenuItem key={game.id} value={game.id}>
                                        {game.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <Button
                                  variant='contained'
                                  onClick={generateGameUrl}
                                  disabled={
                                    !gameProvider.gameExternalId || loading
                                  }
                                  fullWidth
                                  size='small'
                                >
                                  Generate URL
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                          {generatedGameUrl && (
                            <Grid item xs={12}>
                              <Box
                                sx={{
                                  mt: 2,
                                  p: 2,
                                  bgcolor: '#f5f5f5',
                                  borderRadius: 1,
                                }}
                              >
                                <Typography variant='subtitle2' gutterBottom>
                                  Generated Game URL:
                                </Typography>
                                <TextField
                                  fullWidth
                                  value={generatedGameUrl}
                                  variant='outlined'
                                  size='small'
                                  multiline
                                  rows={2}
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                  sx={{ mb: 1 }}
                                />
                                <Button
                                  variant='outlined'
                                  size='small'
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      generatedGameUrl
                                    );
                                    alert('URL copied to clipboard!');
                                  }}
                                >
                                  Copy URL
                                </Button>
                              </Box>
                            </Grid>
                          )}
                        </>
                      )}
                    </>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid> */}

					{/* Images Card */}
					{id !== "create" && (
						<Grid item xs={12}>
							<Card>
								<CardHeader title="Images" />
								<CardContent>
									<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
										<Tabs value={activeLanguageTab} onChange={handleLanguageTabChange} aria-label="language tabs">
											{langs.map((lang, index) => (
												<Tab key={lang.key} label={lang.label} id={`language-tab-${index}`} aria-controls={`language-tabpanel-${index}`} />
											))}
										</Tabs>
									</Box>
									{langs.map((lang, index) => (
										<TabPanel key={lang.key} value={activeLanguageTab} index={index}>
											<GameProviderImages gameProvider={gameProvider} onChange={setGameProvider} language={lang.key} />
										</TabPanel>
									))}
								</CardContent>
							</Card>
						</Grid>
					)}

					<Grid item xs={12}>
						<Card>
							<CardHeader title="Background Color" />
							<CardContent sx={{ overflow: "visible", position: "relative" }}>
								<input
									type="color"
									value={gameProvider.backgroundColor}
									onChange={(e) =>
										setGameProvider((prevState) => ({
											...prevState,
											backgroundColor: e.target.value,
										}))
									}
									style={{
										height: "50px",
										border: "none",
										cursor: "pointer",
									}}
								/>
							</CardContent>
						</Card>
					</Grid>

					{/* Tags Card */}
					{/* {id !== 'create' && (
            <Grid item xs={12}>
              <Card sx={{ minHeight: 300 }}>
                <CardHeader title='Tags' />
                <CardContent sx={{ overflow: 'visible', position: 'relative' }}>
                  <GameTagSearch
                    onUserSelect={handleUserIdsChange}
                    users={gameProvider.tags}
                  />
                </CardContent>
              </Card>
            </Grid>
          )} */}
				</Grid>
			)}
		</Box>
	);
}
